import {
  editBrandFetched,
  resetBrandEdit,
  startLoading,
  stopLoading,
} from './brand-edit.actions';
import { AppState } from '../reducers';
import { Action } from 'redux';
import { CmsBrand } from '../Entities/CmsBrands/cmsbrands.reducer';
import { ImmutableObject } from 'seamless-immutable';
import * as Immutable from 'seamless-immutable';
import { isType } from 'typescript-fsa/lib';

export interface BrandEdit {
  activeAppId: number;
  cmsBrand: CmsBrand;
  loading: boolean;
}

export type BrandEditState = BrandEdit & ImmutableObject<BrandEdit>;
const initialState = Immutable.from<BrandEdit>({
  activeAppId: 139,
  cmsBrand: {} as CmsBrand,
  loading: false,
});

export default function reduce(
  state: BrandEditState = initialState,
  action: Action
) {
  if (isType(action, resetBrandEdit)) {
    return initialState;
  }

  if (isType(action, editBrandFetched)) {
    const { payload } = action;
    const { cmsBrand } = payload;

    return state.merge({ cmsBrand }, { deep: true });
  }

  if (isType(action, startLoading)) {
    return state.merge({ loading: true });
  }

  if (isType(action, stopLoading)) {
    return state.merge({ loading: false });
  }

  return state;
}

export function getBrandEditCmsBrand(state: AppState) {
  const {
    brandEdit: { cmsBrand },
  } = state;
  return cmsBrand;
}

export function isLoading(state: AppState): boolean {
  const {
    brandEdit: { loading },
  } = state;
  return loading;
}



// WEBPACK FOOTER //
// ./src/store/BrandEdit/brand-edit-reducer.ts